import { APIcon } from '@components/atoms/APIcon';
import { Typography } from '@components/atoms/Typography';

export const PoweredByAstroPay = () => {
  return (
    <div className="flex items-center justify-center gap-[6px] mb-4">
      <APIcon img="lockLine" size={11} className="!mr-0" />
      <Typography
        textKey="Checkout.secureCheckoutPoweredBy"
        className="text-[11px] text-[#8A908F]"
      />
      <Typography
        text="AstroPay"
        weight={700}
        variant="span"
        className="text-[11px] text-[#4A4F4E]"
      />
    </div>
  );
};
